import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const TOKEN_KEY = "endeavorum.session";

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem(TOKEN_KEY);
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const setSession = (token) => localStorage.setItem(TOKEN_KEY, token);
export const clearSession = () => localStorage.removeItem(TOKEN_KEY);
export const hasSession = () => Boolean(localStorage.getItem(TOKEN_KEY));

/** Mint a single-use token that carries identity across an origin boundary. */
export const mintCrossing = async (to, path) => {
  const { data } = await api.post("/seam/cross", { to, path: path || null });
  return data;
};

/** Redeem a crossing token for a session on THIS origin. */
export const redeemCrossing = async (crossingToken, portal) => {
  const { data } = await api.post("/auth/cross", {
    crossing_token: crossingToken,
    portal: portal || "endeavorum",
  });
  setSession(data.token);
  return data;
};
